import TvPlaylistState from 'app/routes/tv/types/TvPlaylistState';
import {PlaylistActionType, TvPlaylistAction} from 'app/routes/tv/types/TvPlaylistAction';
import Playlist from 'app/components/tv/models/Playlist';

export default function TvPlaylistPageReducer(state: TvPlaylistState, action: TvPlaylistAction): TvPlaylistState {
  switch (action.type) {
    case PlaylistActionType.PLAYLIST_FETCHING:
      return {...state, isFetching: true};
    case PlaylistActionType.PLAYLIST_UPDATE:
      return {
        ...state,
        isFetching: false,
        playlist: action.data.playlist,
        currentVideo: action.data.currentVideo,
        ssrLoaded: false,
      };
    case PlaylistActionType.ADD_PLAYLIST_VIDEO:
      const currentPlaylist = state.playlist;
      const newVideoList = !currentPlaylist ? [action.data] : [...currentPlaylist.getVideos(), action.data];
      const newPlaylist = Playlist.createByVideoList(newVideoList);
      return {...state, playlist: newPlaylist};
    case PlaylistActionType.CURRENT_VIDEO_UPDATE:
      return {...state, currentVideo: action.data};
    default:
      return state;
  }
}
